'use strict';
const fireOnLoad = (callback) => {
    // @ts-ignore
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        callback();
    }
    else {
        // @ts-ignore
        document.addEventListener('DOMContentLoaded', callback);
    }
};
const fireOnVisible = (duration, selector, callback) => {
    if (document.querySelectorAll(selector).length > 0) {
        callback();
    }
    const intervalId = setInterval(() => {
        if (document.querySelectorAll(selector).length > 0) {
            clearInterval(intervalId);
            callback();
        }
    }, duration);
};
const fireOnMutated = function (targetSelector, callback) {
    if (!('MutationObserver' in window)) {
        return; // MutationObserver not available
    }
    const targetNodes = document.querySelectorAll(targetSelector);
    // @ts-ignore
    const observer = new MutationObserver(callback);
    const observerConfig = { attributes: false, childList: true, subtree: true };
    targetNodes.forEach((target) => {
        observer.observe(target, observerConfig);
    });
};
export default {
    bind(strategy, callback, debugMethod = (_message) => { }) {
        if (strategy === undefined || strategy.type === undefined || strategy.type === 'onload') {
            debugMethod('Attaching events on load');
            fireOnLoad(callback);
        }
        else if (strategy.type === 'interval') {
            debugMethod('Setting an interval to wait for element to be in the DOM', strategy.waitForElem);
            const intervalDuration = strategy.duration || 250;
            const selector = strategy.waitForElem;
            fireOnVisible(intervalDuration, selector, () => {
                debugMethod('Attaching events after element was found in the DOM', strategy.waitForElem);
                callback();
            });
        }
        else if (strategy.type === 'observer') {
            debugMethod('Setting a mutation observer for', strategy.wrapper);
            fireOnLoad(callback); // initialize first
            fireOnMutated(strategy.wrapper, () => {
                debugMethod('Reattaching events after element was mutated', strategy.wrapper);
                callback();
            }); // and observer changes to reinit
        }
    }
};
